import InstallScreen from './install-screen';

export default InstallScreen;
